export const TAB_AGREEMENTS = {
	ALL: 'all',
	CREATED: 'created',
	APPROVED: 'approved',
	ACTIVE: 'active',
	PAUSED: 'paused',
	ENDED: 'ended',
	SETTLED: 'settled',
};

export const STATUS_AGREEMENTS = {
	CREATED: 0,
	APPROVED: 1,
	ACTIVE: 2,
	PAUSED: 3,
	ANNEXING: 4,
	SETTLED: 5,
};

export const STATUS_RELATED_PERSONS = {
	REGISTERED: 0,
	ACTIVE: 1,
	INACTIVE: 2,
};

export const STATUS_SUPPLIER_PAYOUTS = {
	CREATED: 1,
	PAID: 2,
	COMPLETED: 3,
	SETTLED: 4
};

export const FINANCING_MODEL = {
	OPERATOR: 1,
	ANIMATOR: 2,
	HYBRID: 3,
};

export const AGREEMENT_TAB = {
	PROGRAM: 'main',
	FINANCING: 'fees',
	SETTINGS_ANIMATOR: 'advanced',
	DOCUMENTS: 'regulation',
	SETTINGS_GENERAL: 'administration',
};

export const AGREEMENT_SECTION = {
	MAIN_PROGRAM: 'main-program',
	MAIN_PERSON_CARD: 'main-operator',
	MAIN_EMAIL_NOTIFY: 'main-emailnotify',
	MAIN_BANK_INTEGRATION: 'main-bank-integration',
	MAIN_REPAYMENT_ACCOUNT: 'main-repayment-account',
	MAIN_PAYMENT_ACCOUNT: 'main-payment-account',
	MAIN_GAMIFICATION: 'main-gamification',
	FEES_SUPPLIERS: 'fees-suppliers',
	FEES_PAYMENTS: 'fees-payments',
	FEES_CLIENT: 'fees-client',
	FEES_TAXES: 'fees-taxes',
	ADVANCED_SETTINGS: 'advanced-settings',
	REGULATION_ORDER: 'regulation-order',
	INVITATION_TEMPLATE: 'invitation-template',
	ADMINISTRATION_SETTINGS: 'administration-settings',
};
